export default "__VITE_ASSET__CXR$YfcP__"